import moment from 'moment';
import momentTimezone from 'moment-timezone';

const COUNTRY_TIMEZONES = {
  cl: 'America/Santiago',
  pe: 'America/Lima',
  co: 'America/Bogota',
};

export const getTimezoneByCountry = (country) => {
  if (country && COUNTRY_TIMEZONES[country]) {
    return COUNTRY_TIMEZONES[country];
  }
  return COUNTRY_TIMEZONES.cl;
};
export const formatDate = (
  date, 
  format = 'DD-MM-YYYY | HH:mm',
  useFormatForParsing = false, 
  fromTimezone,
  countryTimezone
) => {
  if (!date) return null;
  
  let momentDate;
  
  if (!moment.isMoment(date)) {
    if (useFormatForParsing) {
      momentDate = fromTimezone
        ? momentTimezone.tz(date, format, fromTimezone)
        : moment(date, format);
    } else if (typeof date === 'string' && (date.includes('T') || date.includes('Z'))) {
      momentDate = fromTimezone ? momentTimezone.tz(date, fromTimezone) : moment(date);
    } else {
      momentDate = fromTimezone
        ? momentTimezone.tz(date, 'YYYY-MM-DD HH:mm:ss', fromTimezone)
        : moment(date, 'YYYY-MM-DD HH:mm:ss');
    }
  } else {
    momentDate = date;
  }
  
  if (countryTimezone) {
    const toTimezone = getTimezoneByCountry(countryTimezone);
    if (fromTimezone) {
      return momentTimezone.tz(momentDate, fromTimezone).tz(toTimezone).format(format);
    }
    return momentTimezone(momentDate).tz(toTimezone).format(format);
  }
  
  if (fromTimezone) {
    return momentTimezone.tz(momentDate, fromTimezone).format(format);
  }
  
  return momentDate.format(format);
};
